<template>
  <span class="toolOption">
    <button type="button" class="toolbarBtn"
      :class="{active: option}"
      @mousedown.prevent
      @click="onClickOption">
      <img :src="require(`@/assets/img/CITEditor/align_${alignValue}.svg`)" alt="font size" title="font size" />
    </button>
    <div v-show="option" class="optionGroup">
      <button type="button" class="optionItem"
        v-for="val in align"
        :key="val"
        :class="{active: alignValue === val}"
        @mousedown.prevent
        @click="onSelectOption($event, val)">
        <img :src="require(`@/assets/img/CITEditor/align_${val}.svg`)" :alt="`align ${val}`" :title="`align ${val}`" />
      </button>
    </div>
  </span>
</template>

<script>
export default {
  name: 'TextAlign',
  props: [
    'active',
    'value',
    'option'
  ],
  computed: {
    alignValue () {
      const value = this.align.includes(this.value) ? this.value : 'left'
      return value
    }
  },
  data () {
    return {
      align: [
        'left',
        'center',
        'right',
        'justify'
      ]
    }
  },
  methods: {
    // open option:: fontsize
    onClickOption (e) {
      this.$emit('setOption', { name: 'TextAlign', state: true })
    },
    onSelectOption (e, val) {
      e.preventDefault()
      val = val === 'justify' ? 'full' : val
      const alignText = `justify${val}`
      document.execCommand(alignText, false)
      this.$emit('setValue', { name: 'TextAlign', value: val })
    },
    onClick (align) {
      // this.checkSelection()
      const alignText = `justify${align}`
      document.execCommand(alignText, false)
      this.$emit('setValue', { name: 'TextAlign', value: align })
    }
  }
}
</script>

<style lang="scss" scoped>
.citToolbar .optionGroup {
  left: 50%;
  width: 44px;
  min-width: 0;
  margin-left: -22px;
  .optionItem {
    padding: 8px;
    text-align: center;
    img {
      width: 20px;
    }
  }
}
</style>
